// @flow

import { deviceFingerprint } from '@ebanx/ebanx-js';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';

export class FingerprintError extends Error {
  constructor(message: string) {
    super(`FingerprintError: ${message}`);
  }
}

export function fingerprint(payment: IncomingPayment): Promise<?string> {
  return Promise.race([
    deviceFingerprint.getSession().then(({ device_id }) => device_id),
    delayedException(new FingerprintError('Waited too much for fingerprint providers complete'), 30000),
  ]);
}

function delayedException(error: Error, timeout: number): Promise<void> {
  return new Promise((resolve, reject) => setTimeout(() => reject(error), timeout));
}
